import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, cuentaMask } from "../Components/Items";

moment.locale("es");

const reporteDeCuentasPorPagarAgrupado = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;

  let filtrados = [];
  if (values.fechaVencimiento) {
    filtrados.push([
      { text: "Fecha de Corte:", style: "subheader" },
      {
        text: moment(values.fechaVencimiento).format("DD/MM/YYYY"),
        style: "textoChico",
      },
    ]);
  }

  if (values.proveedores?.length > 0) {
    let texto = "";
    values.proveedores.forEach((p) => {
      texto += `${p.razonSocial ? p.razonSocial : (p.nombre + " " + p.apellidoPaterno + " " + p.apellidoMaterno)} - ${p.rfc}\n`;
    });
    filtrados.push([
      { text: "Proveedores:", style: "subheader" },
      { text: texto, style: "textoChico" },
    ]);
  }

  if (values.filtrarProyecto === 1) {
    let texto = "";
    values.proyectos.forEach((p) => (texto += `${p.nombre}\n`));
    filtrados.push([
      { text: "Proyectos:", style: "subheader" },
      { text: texto, style: "textoChico" },
    ]);
  }

  if (values.filtrarProyecto === 2 && values.unidadDeNegocio) {
    filtrados.push([
      { text: "Unidad de Negocio:", style: "subheader" },
      {
        text:
          cuentaMask(
            (values.unidadDeNegocio.nivel1 || "") +
              (values.unidadDeNegocio.nivel2 || "") +
              (values.unidadDeNegocio.nivel3 || "") +
              (values.unidadDeNegocio.nivel4 || "") +
              (values.unidadDeNegocio.nivel5 || ""),
          ) +
          " - " +
          (values.unidadDeNegocio.nombre || ""),
        style: "textoChico",
      },
    ]);
  }

  if (filtrados.length === 0) {
    filtrados.push([
      { text: "No tiene filtrados adicionales", style: "subheader" },
      { text: "", style: "textoChico" },
    ]);
  }

  const tablasDinamicas = [];

  let granTotalTotales = 0;
  let granTotalAbonos = 0;
  let granTotalSaldo = 0;
  let granTotalVencido = 0;
  let granTotalNoVencido = 0;

  values.facturas.forEach((grupo, index) => {
    tablasDinamicas.push({
      style: "tableExample",
      pageBreak: (values.saltoPaginaPorCliente && index > 0) ? 'before' : undefined,
      table: {
        widths: ["100%"],
        body: [
          [
            {
              text: [ grupo.proveedor, grupo.proveedorRfc ? { text: '\n' + grupo.proveedorRfc, style: 'rfcClienteTabla' } : '' ],
              style: "clienteTabla",
              alignment: "center",
            },
          ],
        ],
      },
      margin: [0, 5, 0, 0],
    });

    let gruposFacturas = [];
    let facturaActual = [];

    for (const f of grupo.facturas) {
      // Verificar si es un producto desglosado/insumo
      const esInsumo =
        values.desglosarProductos &&
        (!f.folio || f.folio === "" || f.insumo === true);

      if (!esInsumo) {
        if (facturaActual.length > 0) gruposFacturas.push(facturaActual);
        facturaActual = [f];
      } else {
        facturaActual.push(f);
      }
    }
    if (facturaActual.length > 0) gruposFacturas.push(facturaActual);

    const porMoneda = {};

    gruposFacturas.forEach((chunk) => {
      const padre = chunk[0];
      const monedaKey = padre.moneda || "Sin Moneda";
      if (!porMoneda[monedaKey]) porMoneda[monedaKey] = [];
      porMoneda[monedaKey].push(...chunk);
    });

    //Generar Tablas por Moneda
    Object.keys(porMoneda).forEach((moneda) => {
      const items = porMoneda[moneda];

      let totalTotales = 0;
      let totalAbonos = 0;
      let totalSaldo = 0;
      let totalVencido = 0;
      let totalNoVencido = 0;

      const filasTabla = items.map((f) => {
        const esInsumo =
          values.desglosarProductos &&
          (!f.folio || f.folio === "" || f.insumo === true);
        const properties = f.colorStyle ? { background: f.colorStyle } : {};

        if (!esInsumo) {
          const total = Number(f.totalPagar || 0);
          const totalPagado = Number(f.totalPagado || 0);
          const saldo = Number(f.saldo ?? total - totalPagado);

          // Sumar acumulados
          totalTotales += total;
          totalAbonos += totalPagado;
          totalSaldo += saldo;

          let diasVencido = 0;
          let esVencida = false;

          if (
            f.fechaVencimiento &&
            moment(f.fechaVencimiento, "DD/MM/YYYY", true).isValid()
          ) {
            if (moment(f.fechaVencimiento, "DD/MM/YYYY").isBefore(moment())) {
              diasVencido = moment().diff(
                moment(f.fechaVencimiento, "DD/MM/YYYY"),
                "days",
              );
              totalVencido += saldo;
              esVencida = true;
            } else {
              totalNoVencido += saldo;
            }
          }

          const estiloDias = esVencida ? "textoRojo" : "textoTabla";

          return [
            { text: f.folio, style: "textoTabla", alignment: "left" }, //  Folio
            {
              text: f.fechaFactura || "",
              style: "textoTabla",
              alignment: "center",
            }, //  Fecha
            {
              text: f.fechaVencimiento || "",
              style: "textoTabla",
              alignment: "center",
            }, // Vencimiento
            {
              text: diasVencido > 0 ? diasVencido : 0,
              style: estiloDias,
              alignment: "center",
            }, // 4. Días
            {
              text: f.estado || "Pendiente",
              ...properties,
              style: "textoTabla",
              alignment: "left",
            }, //  Estado
            {
              text: dineroDisabledMask(total),
              style: "textoTabla",
              alignment: "right",
            }, // Total
            {
              text: dineroDisabledMask(totalPagado),
              style: "textoTabla",
              alignment: "right",
            }, //  Abonos
            {
              text: dineroDisabledMask(saldo),
              style: "textoTabla",
              alignment: "right",
            }, //  Saldo
          ];
        } else {
          // Insumo
          return [
            { text: "", style: "textoTabla" }, // Vacia
            {
              text: f.fechaFactura || "",
              style: "textoTablaInsumo",
              alignment: "center",
            }, //  Cantidad
            {
              text: f.proveedor || f.cliente || "",
              style: "textoTablaInsumo",
              colSpan: 2,
            }, //  Descripción (ocupa 3 y 4)
            {},
            {
              text: dineroDisabledMask(Number(f.estado || 0)),
              style: "textoTablaInsumo",
              alignment: "right",
            },
            {
              text: dineroDisabledMask(Number(f.totalPagar || 0)),
              style: "textoTablaInsumo",
              alignment: "right",
            }, //  Precio Unit
            {
              text: dineroDisabledMask(Number(f.totalPagado || 0)),
              style: "textoTablaInsumo",
              alignment: "right",
            }, //  Subtotal
            {
              text: dineroDisabledMask(Number(f.saldo || 0)),
              style: "textoTablaInsumo",
              alignment: "right",
            },
          ];
        }
      });

      granTotalTotales += totalTotales;
      granTotalAbonos += totalAbonos;
      granTotalSaldo += totalSaldo;
      granTotalVencido += totalVencido;
      granTotalNoVencido += totalNoVencido;

      if (totalTotales > 0 || totalAbonos > 0 || totalSaldo > 0) {
        filasTabla.push(
          [
            {
              text: `Totales (${moneda}):`,
              colSpan: 5,
              style: "totalesTabla",
              alignment: "left",
            },
            {},
            {},
            {},
            {},
            {
              text: dineroDisabledMask(totalTotales),
              style: "totalesTabla",
              alignment: "right",
            },
            {
              text: dineroDisabledMask(totalAbonos),
              style: "totalesTabla",
              alignment: "right",
            },
            {
              text: dineroDisabledMask(totalSaldo),
              style: "totalesTabla",
              alignment: "right",
            },
          ],
          [
            {
              text: `Total Vencido (${moneda}):`,
              colSpan: 5,
              style: "totalesTabla",
              alignment: "left",
            },
            {},
            {},
            {},
            {},
            {
              text: dineroDisabledMask(totalVencido),
              style: "totalesTabla",
              alignment: "right",
              colSpan: 3,
            },
            {},
            {},
          ],
          [
            {
              text: `Total No Vencido (${moneda}):`,
              colSpan: 5,
              style: "totalesTabla",
              alignment: "left",
            },
            {},
            {},
            {},
            {},
            {
              text: dineroDisabledMask(totalNoVencido),
              style: "totalesTabla",
              alignment: "right",
              colSpan: 3,
            },
            {},
            {},
          ],
        );
      }

      // Push Tabla de la Moneda
      tablasDinamicas.push(
        { text: `Moneda: ${moneda}`, style: "subheader", margin: [0, 2, 0, 2] },
        {
          style: "tableExample",
          table: {
            // Folio(10), Fecha(10), Venc(10), Dias(8), Estado(14), Total(16), Abonos(16), Saldo(16)
            widths: ["10%", "10%", "10%", "8%", "14%", "16%", "16%", "16%"],
            headerRows: 1,
            body: [
              [
                "Folio",
                "Fecha",
                "Vencimiento",
                "Días",
                "Estado",
                "Total",
                "Abonos",
                "Saldo",
              ].map((t) => ({ text: t, style: "tituloTabla" })),
              ...filasTabla,
            ],
          },
          layout: {
            fillColor: (i) => (i % 2 === 0 ? "#f3f3f3" : "#ffffff"),
            hLineWidth: (i, node) =>
              i === 0 || i === node.table.body.length ? 1 : 1,
            vLineWidth: (i, node) =>
              i === 0 || i === node.table.widths.length ? 1 : 1,
            hLineColor: () => "#adaaaa",
            vLineColor: () => "#adaaaa",
            hLineStyle: (i, node) =>
              i === 0 || i === node.table.body.length
                ? null
                : { dash: { length: 2, space: 1 } },
            vLineStyle: (i, node) =>
              i === 0 || i === node.table.widths.length
                ? null
                : { dash: { length: 2 } },
          },
        },
        { text: "", margin: [0, 0, 0, 10] }, // Espacio
      );
    });
  });

  tablasDinamicas.push({
    style: "tableExample",
    table: {
      widths: ["10%", "10%", "10%", "8%", "14%", "16%", "16%", "16%"],
      body: [
        [
          { text: "GRAN TOTAL:", style: "totalesTabla", alignment: "left", colSpan: 5, fillColor: "#aaaaaa" },
          {}, {}, {}, {},
          { text: dineroDisabledMask(granTotalTotales), style: "totalesTabla", alignment: "right", fillColor: "#aaaaaa" },
          { text: dineroDisabledMask(granTotalAbonos), style: "totalesTabla", alignment: "right", fillColor: "#aaaaaa" },
          { text: dineroDisabledMask(granTotalSaldo), style: "totalesTabla", alignment: "right", fillColor: "#aaaaaa" },
        ],
        [
          { text: "GRAN TOTAL VENCIDO:", style: "totalesTabla", alignment: "left", colSpan: 5, fillColor: "#aaaaaa" },
          {}, {}, {}, {},
          { text: dineroDisabledMask(granTotalVencido), style: "totalesTabla", alignment: "right", colSpan: 3, fillColor: "#aaaaaa" },
          {}, {},
        ],
        [
          { text: "GRAN TOTAL NO VENCIDO:", style: "totalesTabla", alignment: "left", colSpan: 5, fillColor: "#aaaaaa" },
          {}, {}, {}, {},
          { text: dineroDisabledMask(granTotalNoVencido), style: "totalesTabla", alignment: "right", colSpan: 3, fillColor: "#aaaaaa" },
          {}, {},
        ],
      ],
    },
    layout: { hLineWidth: () => 1, vLineWidth: () => 1, hLineColor: () => "#aaaaaa", vLineColor: () => "#aaaaaa" },
  });

  return {
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 60],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: {
            defaultBorder: false,
          },
          body: [
            [
              {
                border: [false, false, false, false],
                image: "logo",
                fit: [80, 80],
              },
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [
                      {
                        text: empresa.nombreComercial
                          ? empresa.nombreComercial
                          : empresa.persona
                            ? empresa.nombre
                            : empresa.nombre +
                              " " +
                              empresa.apellidoPaterno +
                              " " +
                              empresa.apellidoMaterno,
                        style: "tableHeader",
                      },
                    ],
                    [
                      {
                        text: "R.F.C: " + empresa.rfc,
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text:
                          (empresa.calle || "") +
                          " " +
                          (empresa.numeroCalle || "") +
                          " " +
                          (empresa.numeroInterior
                            ? empresa.numeroInterior
                            : ""),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text:
                          (empresa.colonia?.tipoAsentamiento || "") +
                          " " +
                          (empresa.colonia?.nombre || "") +
                          " C.P. " +
                          (empresa.colonia?.cp || "") +
                          " " +
                          (empresa.municipio?.nombre || "") +
                          " " +
                          (empresa.estado?.abreviatura || "") +
                          " " +
                          (empresa.pais?.abreviatura || "") +
                          " ",
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "REPORTE DE CUENTAS POR PAGAR",
                        style: "tableHeader",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
              {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [
                      {
                        text: "Fecha de Impresión:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: moment().locale("es").format("LL"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: "Desglose:",
                        style: "subheader",
                        alignment: "center",
                      },
                    ],
                    [
                      {
                        text: values.detalle ? "Si" : "No",
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
      },
      { text: "Datos de filtrado:" },
      {
        table: {
          widths: ["20%", "80%"],
          layout: {
            defaultBorder: false,
          },
          body: filtrados,
        },
      },

      ...tablasDinamicas,
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 12,
        color: "black",
        alignment: "center",
      },
      subheader: { bold: true, fontSize: 8 },
      textoChico: { fontSize: 8 },
      textoTabla: { fontSize: 8 },
      textoRojo: { fontSize: 8, color: "red", bold: true },
      textoTablaInsumo: {
        fontSize: 7,
        italics: true,
        color: "#666666",
      },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        style: "subheader",
        alignment: "center",
        border: true,
      },
      totalesTabla: {
        fontSize: 8,
        bold: true,
        italics: false,
        fillColor: "#cccccc",
      },
      clienteTabla: {
        fontSize: 10,
        bold: true,
        italics: false,
        fillColor: "#ecfdfe",
      },
      rfcClienteTabla: {
        fontSize: 8,
        bold: false,
        color: "#444444",
      },
    },
  };
};

export default reporteDeCuentasPorPagarAgrupado;
